var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCodeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 14,
    viewBox: "0 0 25 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.625 9.09394V9.30609L0.806844 9.41536L7.30684 13.3214L7.5 13.4375L7.69316 13.3214L14.1932 9.41536L14.375 9.30609V9.09394V7.29257C14.375 6.81323 13.8539 6.43768 13.3898 6.71754C13.3897 6.71761 13.3896 6.71768 13.3895 6.71775L7.5 10.2536L1.61051 6.71775C1.61035 6.71766 1.61019 6.71756 1.61003 6.71746C1.14602 6.43775 0.625 6.81327 0.625 7.29257V9.09394Z",
    stroke: "#3C3E4C",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78524 8.30839L5.375 8.72039V8.00098V2.14711V1.95173L5.21488 1.83978L3.64248 0.740419C3.64233 0.740308 3.64217 0.740198 3.64201 0.740088C3.40499 0.573772 3.12466 0.601667 2.92527 0.743402C2.73495 0.878685 2.625 1.10611 2.625 1.34986V6.3991C2.625 6.60328 2.70282 6.8615 2.92991 7.01226L4.78524 8.30839Z",
    stroke: "#3C3E4C",
    strokeWidth: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 8V8.71942L10.2148 8.30742L12.0701 7.01128C12.2972 6.86052 12.375 6.6023 12.375 6.39812V1.34889C12.375 1.10513 12.2651 0.877709 12.0747 0.742426C11.8753 0.600693 11.595 0.572797 11.358 0.739102C11.3578 0.739215 11.3577 0.739329 11.3575 0.739442L9.78512 1.8388L9.625 1.95076V2.14613V8Z",
    stroke: "#3C3E4C",
    strokeWidth: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.875 2.50098V1.7308L9.26873 2.20578L7.5 3.59149L5.73127 2.20578L5.125 1.7308V2.50098V8.50098V8.68348L5.26862 8.79609L7.12266 10.2497L7.13576 10.26L7.14971 10.269C7.36713 10.4103 7.63287 10.4103 7.85029 10.269L7.86424 10.26L7.87734 10.2497L9.73138 8.79609L9.875 8.68348V8.50098V2.50098Z",
    stroke: "#3C3E4C",
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeLogo);
export default __webpack_public_path__ + "static/media/code_logo.6cb6f17336f73e5856f77b0c89188733.svg";
export { ForwardRef as ReactComponent };